export * from './lib/base/medrecord-icon';
export * from './lib/medrecord-icons.module';

/* Icons */
export * from './lib/icons';
